export default __webpack_public_path__ + "assets/models/227183f28c38e68aa142873e13df599e.glb";